export default function(eventName, obj = {}) {
  landingPageEvent(eventName, obj)
}

const landingPageEvent = (eventName, obj) => {
  if (window.fbq) {
    window.fbq('track', eventName, obj);
  } else {
    setTimeout(() => {
      landingPageEvent(eventName, obj)
    }, 500)
  }
}



// WEBPACK FOOTER //
// ./client/events/facebookEvent.js